import component from './basketButton.component'
import './basketButton.scss'

let module = angular.module('basketButton', [])
	.component('basketButton', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/basketButton/basketButton.js